import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CalendarPlus, Repeat, FileText, Wrench } from "lucide-react";

const LINKS = [
  { icon: CalendarPlus, label: "Extend your rental", to: "/account?tab=history" },
  { icon: Repeat, label: "Swap your car", to: "/account?tab=services" },
  { icon: FileText, label: "Download invoices", to: "/account?tab=history" },
  { icon: Wrench, label: "Book a service", to: "/account?tab=services" },
];

export const SelfServiceStrip = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-[#f0f9f0] border-y border-[#009900]/15" data-testid="self-service-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <h2 className="heading-upper text-lg text-[#144733]">{t("Your rental, your rules")}</h2>
        <p className="text-sm text-[#57685e] mt-1">{t("Extend your rental, swap your car, download invoices, book a service — log into your account and make the change in a few clicks.")}</p>
        <div className="flex flex-wrap gap-3 mt-4">
          {LINKS.map((l) => (
            <Link key={l.label} to={l.to} className="flex items-center gap-2 bg-white border border-[#d5ddd5] rounded-full px-4 py-2 text-xs font-semibold text-[#144733] hover:border-[#009900] transition-colors"
              data-testid={`self-service-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <l.icon className="w-4 h-4 text-[#009900]" /> {t(l.label)}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
